'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.styles = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ToggleButton = require('@material-ui/lab/ToggleButton');

var _ToggleButton2 = _interopRequireDefault(_ToggleButton);

var _styles = require('../styles');

var _tokens = require('../styles/tokens');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = exports.styles = function styles(theme) {
    return {
        root: {
            border: 'none',
            '&:hover': {
                backgroundColor: _tokens.colorBrandNeutral200,
                borderColor: 'none'
            },
            '&:focus': {
                boxShadow: '0 0 0 ' + _tokens.borderWidthThick + ' ' + theme.palette.focus,
                '& svg': {
                    fill: _tokens.colorBrandNeutral600
                }
            },
            '&:disabled': {
                backgroundColor: _tokens.colorBrandNeutral250,
                '& svg': {
                    fill: _tokens.colorBrandNeutral400
                }
            },
            '&$selected': {
                backgroundColor: _tokens.colorBrandNeutral300,
                '& svg': {
                    fill: _tokens.colorBrandNeutral600
                },
                '&:hover': {
                    backgroundColor: _tokens.colorBrandNeutral200,
                    borderColor: 'none'
                },
                '&:focus': {
                    boxShadow: '0 0 0 ' + _tokens.borderWidthThick + ' ' + theme.palette.focus
                },
                '&:disabled': {
                    backgroundColor: _tokens.colorBrandNeutral250,
                    '& svg': {
                        fill: _tokens.colorBrandNeutral400
                    }
                }
            }
        },
        label: {
            color: _tokens.colorBrandNeutral500,
            '& svg': {
                fill: _tokens.colorBrandNeutral500
            }
        },
        selected: {}
    };
};

/**
 * Toggle buttons can be used to group related options.
 * @done true
 * @updated false
 * @versionAdded v5.3.0
 * @examples
 *  ToggleButtonDefaultExample
 *  ToggleButtonGroupExample
 */
var ToggleButton = _react2.default.forwardRef(function (props, ref) {
    var classes = props.classes,
        children = props.children,
        value = props.value,
        size = props.size,
        selected = props.selected,
        disabled = props.disabled,
        rest = _objectWithoutProperties(props, ['classes', 'children', 'value', 'size', 'selected', 'disabled']);

    var classOverrides = {
        root: classes.root,
        label: classes.label,
        selected: classes.selected
    };

    return _react2.default.createElement(
        _ToggleButton2.default,
        Object.assign({
            value: value,
            disableFocusRipple: true,
            disableRipple: true,
            classes: classOverrides,
            size: size,
            selected: selected,
            disabled: disabled
        }, rest),
        children
    );
});

ToggleButton.muiName = 'ToggleButton';
ToggleButton.displayName = 'ToggleButton';

ToggleButton.propTypes = {
    /**
    * Class name to assign the component.
    */
    className: _propTypes2.default.string,
    /**
     * Classes used to extend original style object.
     */
    classes: _propTypes2.default.object,
    /**
     * The content of the button.
     */
    children: _propTypes2.default.node.isRequired,
    /**
     * If `true`, the button will be disabled.
     */
    disabled: _propTypes2.default.bool,
    /**
     * Callback fired when the value changes.
     *
     * **Signature:**
     * ```
     * function(event: object, value: any) => void
     * ```
     * `event`: The event source of the callback.
     *
     * `value`: of the button.
     */
    onChange: _propTypes2.default.func,
    /**
     * If `true`, the button will be rendered in an active state.
     */
    selected: _propTypes2.default.bool,
    /**
     * The size of the button.
     */
    size: _propTypes2.default.oneOf(['large', 'medium', 'small']),
    /**
     * The value to associate with the button when selected.
     */
    value: _propTypes2.default.any

};

ToggleButton.defaultProps = {
    size: 'medium',
    disabled: false
};

exports.default = (0, _styles.withStyles)(styles)(ToggleButton);